import orderBy from 'lodash/orderBy';

export const sortAscToDesc = (x, y) => {
  const a = x.firstName.toUpperCase();
  const b = y.firstName.toUpperCase();

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

export const sortDescToAsc = (x, y) => {
  const a = x.firstName.toUpperCase();
  const b = y.firstName.toUpperCase();

  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};

export const sortActivityDescToAsc = (x, y) => {
  const a = parseInt(x.assignmentCount, 10);
  const b = parseInt(y.assignmentCount, 10);

  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};

export const sortActivityAscToDesc = (x, y) => {
  const a = parseInt(x.assignmentCount, 10);
  const b = parseInt(y.assignmentCount, 10);

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

export const customSort = (list = [], primaryField, sortDirection) => {
  const orderedList = orderBy(
    list,
    item => (isNaN(item[primaryField]) ? item[primaryField].toLowerCase() : item[primaryField]),
    [sortDirection]
  );
  return orderedList;
};



// WEBPACK FOOTER //
// ./components/student-list/utils.js